var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img",class:_vm.size,style:({ backgroundImage: _vm.backgroundImage, backgroundColor: _vm.backgroundColor })},[(!_vm.image)?_c('span',[_vm._v(_vm._s(_vm.altName))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }